import * as React from 'react';
import hideDialogAndInvokeCallbackOnError from '../utils/hideDialogAndInvokeCallbackOnError';
import hideDialogAndTriggerTokenFlowOnSuccess from '../utils/hideDialogAndTriggerTokenFlowOnSuccess';
import strings from 'owa-strings/owa-extensibility-strings';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { getSsoDialog } from 'owa-addins-store';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { SsoErrorCode } from '../schema/SsoErrorCode';

export default class SsoMfaSignInDialog extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <div>
                <Label>{strings.ssoSignInLabelText}</Label>
                <DialogFooter>
                    <PrimaryButton
                        onClick={this.onSignInClick.bind(this)}
                        text={strings.ssoSignInButtonText}
                    />
                    <DefaultButton
                        onClick={this.onDismiss.bind(this)}
                        text={strings.ssoSignInCloseButtonText}
                    />
                </DialogFooter>
            </div>
        );
    }

    private onSignInClick() {
        const dialog = getSsoDialog();
        hideDialogAndTriggerTokenFlowOnSuccess(dialog.controlId, dialog.authChallenge);
    }

    private onDismiss() {
        hideDialogAndInvokeCallbackOnError(SsoErrorCode.UserAborted);
    }
}
